import { mapJsonQuery } from './jsonQuery';
import { TSearchPromosResponse_1 } from '../repositories/newbuilding-promos/v2/search-promos';
import { ITag } from '../types/tags';

export const mapTags = (promosResponse: TSearchPromosResponse_1): ITag[] => {
  return promosResponse.tags.map(tag => ({
    jsonQuery: mapJsonQuery(tag.jsonQuery),
    name: tag.name,
  }));
};
